import LandingPage from '../components/Landing/LandingPage';
import TermsOfService from '../components/Landing/TermsOfService';
import PrivacyPolicy from '../components/Landing/PrivacyPolicy';
import Disclaimer from '../components/Landing/Disclaimer';
import ResponsibleGambling from '../components/Landing/ResponsibleGambling';
import DashboardLayout from '../components/DashboardLayout/DashboardLayout';
import ResultsTracker from '../components/ResultsTracker/ResultsTracker';
import OddsScreen from '../components/OddsScreen/OddsScreen';
import Discord from '../components/Discord/Discord';
import ManageSubscriptions from '../components/ManageSubscriptions/ManageSubscriptions';
import ProtectedRoute from '../components/ProtectedRoute';

const routes = [
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/terms',
    element: <TermsOfService />,
  },
  {
    path: '/privacy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/disclaimer',
    element: <Disclaimer />,
  },
  {
    path: '/responsible-gambling',
    element: <ResponsibleGambling />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'discord',
        element: <Discord />,
      },
      {
        path: 'manage-subscriptions',
        element: <ManageSubscriptions />,
      },
      {
        path: 'snipe-feed',
        element: <OddsScreen />,
      },
      {
        path: 'results-tracker',
        element: <ResultsTracker />,
      },
    ],
  },
];

export default routes;

